import { render, staticRenderFns } from "./ProjectSidebar.vue?vue&type=template&id=291f472f&scoped=true"
import script from "./ProjectSidebar.vue?vue&type=script&lang=js"
export * from "./ProjectSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProjectSidebar.vue?vue&type=style&index=0&id=291f472f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f472f",
  null
  
)

export default component.exports